import type { RegistrationProfileView } from '@galapagos/shared';
import { SIGNUP_LOGIN_NO_PROGRESS_PAGE, type SignupPageId } from '../off-path-pages';
import type { SignupStepId } from '../steps';

/** The flow's download page, where a member who already finished signing up lands. */
export const SIGNUP_DOWNLOAD_STEP: SignupStepId = 'download';

/**
 * Where a returning member goes after signing in, from the Galapagos
 * registration profile alone (null when it could not be read). Saved details
 * mean signup is done, as production treats saved details. Anything else has
 * nothing to resume from: the substance choice and legal name live only in
 * the browser that entered them, and a minor or a pending consent has no
 * destination here yet.
 */
export function loginDestination(profile: RegistrationProfileView | null): SignupPageId {
  if (
    profile !== null &&
    profile.completedAt !== null &&
    profile.registrationGate === 'proceed' &&
    !profile.consentPending
  ) {
    return SIGNUP_DOWNLOAD_STEP;
  }
  return SIGNUP_LOGIN_NO_PROGRESS_PAGE;
}
